function initActivityDetails() {

	// $('.popup-with-move-anim').magnificPopup({
	// 	type: 'inline',
	//
	// 	fixedContentPos: true,
	// 	fixedBgPos: true,
	//
	// 	overflowY: 'auto',
	//
	// 	closeBtnInside: true,
	// 	closeOnContentClick: true,
	// 	preloader: false,
	//
	// 	midClick: true,
	// 	removalDelay: 300,
	// 	mainClass: 'my-mfp-slide-bottom'
	// });



	$('[data-popup]').on('click', function() {
		var targetId = $(this).data('popup');

		$.magnificPopup.open({
			items: {
				src: $('#'+targetId)
			},
			type: 'inline',
			fixedContentPos: true,
			fixedBgPos: true,

			overflowY: 'auto',

			closeBtnInside: true,
			closeOnContentClick: true,
			preloader: false,

			midClick: true,
			removalDelay: 300,
			mainClass: 'my-mfp-slide-bottom'

		});
	});
}
    